<template>
  <div id="privacy-policy">
    <div class="title"></div>
    <div class="area">
      <div class="policy">
        <h1>プライバシーポリシーについて</h1>
        <h3>対象</h3>
        <p>
          「どんぐりのレストラン」アプリケーション・プライバシーポリシー（以下「本ポリシー」といいます）は、株式会社コスモジャパン（以下「当社」といいます）が提供する携帯端末（ただし、Google
          Inc.が提供するOS「Android」、Apple
          Inc.が提供するOS「iOS」を利用できる携帯端末に限ります、以下「携帯端末」といいます）向けゲームアプリケーション「どんぐりのレストラン」（以下「本アプリ」といいます）における個人情報の取扱を定めたものです。
        </p>
      </div>
      <div class="policy">
        <h2>2． 個人情報の取得、利用目的</h2>
        <h3>取得する情報の一覧</h3>
        <p>
          当社は、本アプリの提供にあたり、お客様から以下の情報を取得する場合があります。
          <br />・ユーザー名 <br />・本アプリの利用状況
          <br />・お問い合わせの際にご提供いただいた情報
          <br />・利用者の端末を識別する、ID、OSのバージョンなどの端末に関する情報
          <br />
          <br />
        </p>
        <h3>利用目的</h3>
        <p>
          当社は、取得した情報を以下の目的で利用いたします。
          <br />・本アプリのサービス提供
          <br />・当社とお客様間のコミュニケーション
          <br />・安心・安全なコミュニケーション環境の実現
          <br />・本アプリの利用状況及び各種施策の実施結果の測定、調査、分析
          <br />・本アプリの改善、不具合対応
          <br />・当社又は第三者が運営する各種サービス、プロモーション、キャンペーン、イベント等のご案内
          <br />・広告表示及びその表示内容の最適化
          <br />・利用規約違反行為の是正
          <br />・お問い合わせ対応（本人確認を含みます）
          <br />・「3．第三者提供」記載の第三者（共同利用者を含む）への提供
          <br />
        </p>
      </div>
      <div class="policy">
        <h2>3．第三者提供</h2>
        <p>
          当社は、「個人情報保護に関する基本方針」の「個人情報の第三者提供について」に記載している場合に個人情報を国内外の第三者に開示する場合があります。
        </p>
      </div>
      <div class="policy">
        <h2>4． 通知・公表又は同意取得の方法、利用者関与の方法</h2>
        <h3>通知・公表</h3>
        <p>
          本ポリシーは、初回起動時の画面及び本アプリ内の説明ページのほか、アプリストア(Google
          Play、App
          Storeなど)の本アプリダウンロードページに設置されたプライバシーポリシーリンクに掲示・公表しております。
          <br />当社は本ポリシーを変更することがあり、重要な変更を行う際は本アプリ内又は各掲示箇所において告知いたします。変更後の本ポリシーは、本アプリ内又は各掲示箇所に掲示された時点から適用されるものとします。
        </p>
        <br />
        <h3>同意取得の方法</h3>
        <p>
          本アプリは利用規約及び本ポリシーをご確認いただき、同意の上でご利用ください。お客様が本アプリを利用すること（変更後の本ポリシーについては、変更後に本アプリの利用継続）を以て、本ポリシーに同意したものとみなされます。
        </p>
        <br />
        <h3>情報の取得・送信の停止</h3>
        <p>
          本アプリを携帯端末より削除(アンインストール)することで、情報の取得及び送信を停止することができます。
        </p>
      </div>
      <div class="policy">
        <h2>5． 管理方針</h2>
        <h3>本プライバシーポリシーの変更</h3>
        <p>
          本プライバシーポリシーの内容は修正・変更されることがあります。修正・変更後の本プライバシーポリシーについては、当社が別途定める場合を除いて、当サイトに掲載したときから効力を生じるものとします。
          <br />
          <br />
          <br />制定：2024年5月1日
          <br />
        </p>
      </div>
    </div>
  </div>
</template>

<style>
#privacy-policy {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.8em;
}

.title {
  width: 200px;
  margin: 10px;
  background-color: #ababab;
}

.area {
  margin: 3%;
  padding: 3%;
  text-align: left;
  background-color: #ffffff;
  border-radius: 5px;
}

.policy {
  margin-bottom: 20px;
}

.h2 {
  font-weight: bold;
  margin: 15px 0;
}

.h3 {
  margin: 15px 0;
}
</style>
